import { useState, useCallback } from 'react';

import { HTMLParagraph } from '@/components/HTMLParagraph';
import { Paragraph } from '@/components/Paragraph';
import { theme } from '@/styles/theme';
import { getIcon } from '@/utils/getIcon';

import {
  StyledIconWrapper,
  StyledInsight,
  StyledInsightDescription,
  StyledInsightHeader,
  StyledInsightText,
  StyledUnfoldButton,
} from './styles';

import { ChevronBackIcon } from '../Icons';

import type { Insight } from '@/types/itinerary';

function DestinationInsight({ insight }: { insight: Insight }) {
  const [opened, setOpened] = useState<boolean>(false);

  const toggleOpened = useCallback(() => {
    setOpened((prev) => !prev);
  }, [setOpened]);

  return (
    <StyledInsight key={insight.name} $opened={opened} onClick={toggleOpened}>
      <StyledInsightHeader>
        <StyledIconWrapper>{getIcon(insight.name, '2xl')}</StyledIconWrapper>
        <StyledInsightText>
          <Paragraph color="primary" size="sm" weight={600}>
            {insight.name}
          </Paragraph>
          <Paragraph size="xl" weight={600}>
            {insight.value}
          </Paragraph>
        </StyledInsightText>
        <StyledUnfoldButton $opened={opened}>
          <ChevronBackIcon size="lg" color={theme.color.primary} />
        </StyledUnfoldButton>
      </StyledInsightHeader>
      <StyledInsightDescription $opened={opened}>
        <HTMLParagraph weight={400} size="sm" dangerousHTML={insight.paragraph} />
      </StyledInsightDescription>
    </StyledInsight>
  );
}

export { DestinationInsight };
